import { styled } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

export const StyledDesktopDatePicker = styled(DesktopDatePicker)`
  .MuiInputAdornment-root {
    position: absolute;
    right: 10px;
  }
`;
